import { render, staticRenderFns } from "./IconExclamationMark.vue?vue&type=template&id=a3b8eb40&"
import script from "./IconExclamationMark.vue?vue&type=script&lang=js&"
export * from "./IconExclamationMark.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports